/**
 * Single source of truth for "which seat is the local/human player" in
 * offline mode. Every offline table layout, render decision and AI-partner
 * lookup assumes the human always sits at seat 0 — this constant documents
 * that assumption in one place instead of the literal `0` being repeated
 * ad-hoc across the renderer/AI/components.
 *
 * Online mode will need a per-client seat (whichever seat that client's
 * player occupies), not a fixed constant — that generalization is deferred
 * to the client work in Phase 9 of RONDA_ONLINE.md, since it needs a real
 * multi-seat client to design against.
 */
export const LOCAL_PLAYER_INDEX = 0;

export function isLocalPlayer(playerIndex) {
    return playerIndex === LOCAL_PLAYER_INDEX;
}
